<template>
  <div class="carousel-wrap" v-show="visible">
    <i class="iconfont icon-guanbi close-img" :style="{ marginTop: close + 'px' }"  @click="closeCarousel"></i>
    <div id="showBigCarousel" :style="{ marginTop: top + 'px', height: asyncHeight + 'px' }">
      <!--图片展示-->
      <el-carousel :height="asyncHeight + 'px'" :autoplay="false" :arrow="showArrow"
                   :initial-index="currentImg" indicator-position="none" v-if="showType==='image'">
        <el-carousel-item v-for="(imgItem,index) in picArray" :key="index">
          <img v-lazy="imgUrl(imgItem)" alt="">
        </el-carousel-item>
      </el-carousel>
      <!--视频展示-->
      <div class="d-center m-auto" v-if="showType==='video'">
        <embed :src="videoUrl.httpSrc" allowFullScreen="true" quality="high" v-if="videoUrl.httpSrc"
               width="50%" :height="asyncHeight" align="middle" allowScriptAccess="always"
               type="application/x-shockwave-flash"/>
        <video :src="videoUrl.cdnSrc" width="50%" :height="asyncHeight" controls v-if="videoUrl.cdnSrc"></video>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ImgCarouselDialog',
    props: {
      currentImg: {
        type: Number,
        default: 0
      },
      picArray: {
        type: Array,
        default () {
          return []
        }
      },
      showType: {
        type: String,
        default: 'image'
      },
      videoSrc: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        visible: false
      }
    },
    computed: {
      top () {
        return Math.ceil($(window).height() * 0.1)
      },
      close () {
        return Math.ceil($(window).height() * 0.06)
      },
      asyncHeight () {
        return Math.ceil($(window).height() * 0.8)
      },
      showArrow () {
        if (this.picArray.length <= 1) {
          return 'never'
        } else {
          return 'always'
        }
      },
      videoUrl () {
        if (this.videoSrc.indexOf('//player') !== -1) {
          return { httpSrc: this.videoSrc }
        } else {
          return { cdnSrc: this.ImgPreUrl + this.videoSrc }
        }
      }
    },
    mounted () {
      // $(() => {
      //   $('#showBigCarousel').css({
      //     marginTop: $(window).height() * 0.1 + 'px',
      //     height: this.asyncHeight + 'px'
      //   })
      //   $('.close-img').css({ top: $(window).height() * 0.06 + 'px' })
      // })
    },
    methods: {
      closeCarousel() { this.$emit('close'); },
      imgUrl (item) {
        if (item.indexOf(';base64,') !== -1 || item.indexOf('http') !== -1 || item.indexOf('/images/') !== -1) {
          return item
        } else {
          return this.ImgPreUrl + item
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .carousel-wrap {
    background: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    .el-carousel {
      max-width: 70%;
      margin: 0 auto;
      img {
        max-width: 100%;
        max-height: 100%;
      }
      .el-carousel__item {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .close-img {
      font-size: 25px;
      color: #eee;
      position: absolute;
      top: 0;
      right: 12%;
      cursor: pointer;
      transition: all ease 0.5s;
      &:hover {
        color: #fff;
        transform: rotate(180deg) scale(1.5, 1.5);
      }
    }
  }
</style>
